const FORM_SCHEMA_VERSION_1 = {
  postGraduationPlan: 'Undecided',
  createSystem: false,
  confirmCreateSystem: false,
  loginToWeb: false,
  confirmLoginToWeb: false,
  obtainCopies: false,
  confirmObtainCopies: false,
  obtainPermit: false,
  confirmObtainPermit: false,
  registerDriversEd: false,
  confirmRegisterDriversEd: false,
  createEmail: false,
  confirmCreateEmail: false,
  volunteerOpportunities: false,
  confirmVolunteerOpportunities: false,
  cleanUpSocialMedia: false,
  confirmCleanUpSocialMedia: false,
  obtainDriversLicense: false,
  confirmObtainDriversLicense: false,
  boysTownScholarship: false,
  confirmBoysTownScholarship: false,
  secedTakeACTOrAccuplacer: false,
  confirmSecedTakeACTOrAccuplacer: false,
  secedVisitSchools: false,
  confirmSecedVisitSchools: false,
  secedFASID: false,
  confirmSecedFASID: false,
  secedCollegeApplications: false,
  confirmSecedCollegeApplications: false,
  secedACTForwarded: false,
  confirmSecedACTForwarded: false,
  secedFAFSASent: false,
  confirmSecedFAFSASent: false,
  secedStudentAidRpt: false,
  confirmSecedStudentAidRpt: false,
  seced2ScholarshipApps: false,
  confirmSeced2ScholarshipApps: false,
  secedExternalScholarships: false,
  confirmSecedExternalScholarships: false,
  secedAcceptanceLetters: false,
  confirmSecedAcceptanceLetters: false,
  secedStudentId: false,
  confirmSecedStudentId: false,
  secedLogInFinancialAid: false,
  confirmSecedLogInFinancialAid: false,
  secedLogInOtherDocs: false,
  confirmSecedLogInOtherDocs: false,
  secedCampusHousing: false,
  confirmSecedCampusHousing: false,
  secedTranscripts: false,
  confirmSecedTranscripts: false,
  secedNoteDates: false,
  confirmSecedNoteDates: false,
  militaryRecruiter: false,
  confirmMilitaryRecruiter: false,
  militaryASVAB: false,
  confirmMilitaryASVAB: false,
  militaryMEPS: false,
  confirmMilitaryMEPS: false,
  militaryContract: false,
  confirmMilitaryContract: false,
  militaryOathCeremony: false,
  confirmMilitaryOathCeremony: false,
  jobcorpsMeeting: false,
  confirmJobcorpsMeeting: false,
  jobcorpsCareerPath: false,
  confirmJobcorpsCareerPath: false,
  jobcorpsVisitSite: false,
  confirmJobcorpsVisitSite: false,
  jobcorpsRecruiter: false,
  confirmJobcorpsRecruiter: false,
  jobcorpsCompleteApplication: false,
  confirmJobcorpsCompleteApplication: false,
  jobcorpsAdmissionDate: false,
  confirmJobcorpsAdmissionDate: false,
  workforceOccupation: false,
  confirmWorkforceOccupation: false,
  workforceHousing: false,
  confirmWorkforceHousing: false,
  workforceResume: false,
  confirmWorkforceResume: false,
  workforceEmployers: false,
  confirmWorkforceEmployers: false,
  workforceReferences: false,
  confirmWorkforceReferences: false,
  workforceJobApplications: false,
  confirmWorkforceJobApplications: false,
  workforceSecureHousing: false,
  confirmWorkforceSecureHousing: false,
  workforceTransportation: false,
  confirmWorkforceTransportation: false,
  workforceFollowupOnApps: false,
  confirmWorkforceFollowupOnApps: false,
  workforceInterviews: false,
  confirmWorkforceInterviews: false,
  workforceFirstDayOfWork: false,
  confirmWorkforceFirstDateOfWork: false,
  status: 'created',
  dispositionReason: '',
  discussTransportationNeeds: false,
  confirmDiscussTransportationNeeds: false,
  completeDriversEd: false,
  confirmCompleteDriversEd: false,
  liveAfterGraduation: false,
  confirmLiveAfterGraduation: false,
  liveAfterGraduationResponse: '',
  requestLettersofRecommendation: false,
  confirmRequestLettersofRecommendation: false,
  secedCompleteFAFSA: false,
  confirmSecedCompleteFAFSA: false,
  secedLocateStudentAidRpt: false,
  confirmSecedLocateStudentAidRpt: false,
  secCareerStartDates: false,
  confirmSecCareerStartDates: false,
  secCareerSubmitApps: false,
  confirmSecCareerSubmitApps: false,
  secCareerSendDeposits: false,
  confirmSecCareerSendDeposits: false,
  secCareerFinancial: false,
  confirmSecCareerFinancial: false,
  secCareerAcceptFAFSASupport: false,
  confirmSecCareerAcceptFAFSASupport: false,
  secCareerFASID: false,
  confirmSecCareerFASID: false,
  secCareerCompleteFAFSA: false,
  confirmSecCareerCompleteFAFSA: false,
  secCareerLocateStudentAidRpt: false,
  confirmSecCareerLocateStudentAidRpt: false,
  secCareerNecessaryInfo: false,
  confirmSecCareerNecessaryInfo: false,
  secCareerExploreHousing: false,
  confirmSecCareerExploreHousing: false,
  secCareerHousingApps: false,
  confirmSecCareerHousingApps: false,
  secCareerIdentifyTransportation: false,
  confirmSecCareerIdentifyTransportation: false,
  secCareerPartTimeJobs: false,
  confirmSecCareerPartTimeJobs: false,
  secCareerTools: false,
  confirmSecCareerTools: false,
  secCareerBudget: false,
  confirmSecCareerBudget: false,
  secCareerPlanDates: false,
  confirmSecCareerPlanDates: false,
  secCareerPlanStartDates: false,
  confirmSecCareerPlanStartDates: false,
};

export const FORM_SCHEMA_VERSION_2 = {
  // version 2 fields
  // general fields
  createSystem: false,
  confirmCreateSystem: false,
  createEmail: false,
  confirmCreateEmail: false,
  loginToWeb: false,
  confirmLoginToWeb: false,
  obtainCopies: false,
  confirmObtainCopies: false,
  obtainPermit: false,
  confirmObtainPermit: false,
  registerDriversEd: false,
  confirmRegisterDriversEd: false,
  completePlanningMeeting1: false,
  confirmCompletePlanningMeeting1: false,
  completePlanningMeeting2: false,
  confirmCompletePlanningMeeting2: false,
  boysTownScholarship: false,
  confirmBoysTownScholarship: false,
  requestLettersofRecommendation: false,
  confirmRequestLettersofRecommendation: false,
  volunteerOpportunities: false,
  confirmVolunteerOpportunities: false,
  cleanUpSocialMedia: false,
  confirmCleanUpSocialMedia: false,
  completeDriversEd: false,
  confirmCompleteDriversEd: false,
  obtainDriversLicense: false,
  confirmObtainDriversLicense: false,
  liveAfterGraduation: false,
  // career training fields
  secCareerDiplomaNote: false,
  confirmSecCareerDiplomaNote: false,
  secCareerExploreOptions: false,
  confirmSecCareerExploreOptions: false,
  secCareerStartDates: false,
  confirmSecCareerStartDates: false,
  secCareerSubmitApps: false,
  confirmSecCareerSubmitApps: false,
  secCareerFinancialCost: false,
  confirmSecCareerFinancialCost: false,
  secCareerSubmitDeposit: false,
  confirmSecCareerSubmitDeposit: false,
  secCareerFafsaAccept: false,
  confirmSecCareerFafsaAccept: false,
  secCareerFafsaAccount: false,
  confirmSecCareerFafsaAccount: false,
  secCareerFafsaComplete: false,
  confirmSecCareerFafsaComplete: false,
  secCareerFafsaPrintSai: false,
  confirmSecCareerFafsaPrintSai: false,
  secCareerAcceptedInfo: false,
  confirmSecCareerAcceptedInfo: false,
  secCareerHousingOptions: false,
  confirmSecCareerHousingOptions: false,
  secCareerHousingApps: false,
  confirmSecCareerHousingApps: false,
  secCareerTransportation: false,
  confirmSecCareerTransportation: false,
  secCareerPartTimeJob: false,
  confirmSecCareerPartTimeJob: false,
  secCareerEquipment: false,
  confirmSecCareerEquipment: false,
  // college fields
  secedTakeACTOrAccuplacer: false,
  confirmSecedTakeACTOrAccuplacer: false,
  collegeExploreVisit: false,
  confirmCollegeExploreVisit: false,
  collegeFsaAccount: false,
  confirmCollegeFsaAccount: false,
  collegeFafsa: false,
  confirmCollegeFafsa: false,
  collegeSubmitApps: false,
  confirmCollegeSubmitApps: false,
  collegeForwardScores: false,
  confirmCollegeForwardScores: false,
  collegeForwardFafsa: false,
  confirmCollegeForwardFafsa: false,
  collegeLocateSai: false,
  confirmCollegeLocateSai: false,
  collegePrintSai: false,
  confirmCollegePrintSai: false,
  collegeSubmitScholarshipApps: false,
  confirmCollegeSubmitScholarshipApps: false,
  collegeExternalScholarships: false,
  confirmCollegeExternalScholarships: false,
  collegeAcceptanceNotifications: false,
  confirmCollegeAcceptanceNotifications: false,
  collegeStudentIdPassword: false,
  confirmCollegeStudentIdPassword: false,
  collegeReviewFinancialAid: false,
  confirmCollegeReviewFinancialAid: false,
  collegeCheckOtherDocs: false,
  confirmCollegeCheckOtherDocs: false,
  collegeFinalizeHousing: false,
  confirmCollegeFinalizeHousing: false,
  collegeRequestTranscripts: false,
  confirmCollegeRequestTranscripts: false,
  collegeOrientationDates: false,
  confirmCollegeOrientationDates: false,
  // jobcorps fields
  jobcorpsInfoMeeting: false,
  confirmJobcorpsInfoMeeting: false,
  jobcorpsCareerPath: false,
  confirmJobcorpsCareerPath: false,
  jobcorpsSiteVisit: false,
  confirmJobcorpsSiteVisit: false,
  jobcorpsRecruiterMeeting: false,
  confirmJobcorpsRecruiterMeeting: false,
  jobcorpsCompleteApplication: false,
  confirmJobcorpsCompleteApplication: false,
  jobcorpsAdmissionDate: false,
  confirmJobcorpsAdmissionDate: false,
  // military fields
  militaryRecruiter: false,
  confirmMilitaryRecruiter: false,
  militaryASVAB: false,
  confirmMilitaryASVAB: false,
  militaryMEPS: false,
  confirmMilitaryMEPS: false,
  militaryEnlistmentContract: false,
  confirmMilitaryEnlistmentContract: false,
  militaryOath: false,
  confirmMilitaryOath: false,

  // workforce fields
  workforceOccupation: false,
  confirmWorkforceOccupation: false,
  workforceResume: false,
  confirmWorkforceResume: false,
  workforcePotentialEmployers: false,
  confirmWorkforcePotentialEmployers: false,
  workforceReferences: false,
  confirmWorkforceReferences: false,
  workforceApplyJobs: false,
  confirmWorkforceApplyJobs: false,
  workforceSecureHousing: false,
  confirmWorkforceSecureHousing: false,
  workforceTransportation: false,
  confirmWorkforceTransportation: false,
  workforceFollowUp: false,
  confirmWorkforceFollowUp: false,
  workforceInterviews: false,
  confirmWorkforceInterviews: false,
  workforceEquipment: false,
  confirmWorkforceEquipment: false,
  workforceFirstDayOfWork: false,
  confirmWorkforceFirstDateOfWork: false,
};

export const FORM_SCHEMA = {
  ...FORM_SCHEMA_VERSION_1,
  ...FORM_SCHEMA_VERSION_2,
  version: 2,
};
